export { default } from './SinkronisasiMerchant';
